// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__zvhdU","row":"Node_row__2jETC","label":"Node_label__1lhdd","footer":"Node_footer__27Cug"};